<template>
  <div class="layout">
    <div class="header">
      <ol class="wrapp">
        <li @click="$router.push({ path:'/' })">Home</li>
        <li>&nbsp;&nbsp;>&nbsp;&nbsp;download</li>
      </ol>
    </div>
    <div class="box">
      <div class="box_content">
        <div class="logo">
          <img src="https://cdn.hotplaydl.com/static/img/logo.png" alt="logo">
        </div>
        <div class="logo-title">
          GamesToday
        </div>
        <van-button class="downBtn" :icon="download" type="info" @click="downapp">Download Now</van-button>
        <div class="version">
          <img src="https://cdn.hotplaydl.com/static/img/version.png" alt="version">
          <div v-if="version" class="version-word">Version ：{{ version }}</div>
          <img src="https://cdn.hotplaydl.com/static/img/size.png" alt="size">
          <div v-if="size" class="version-word">Size ：{{ size }}M</div>
        </div>
        <div>
          <p class="content">GamesToday is a website providing popular Android game downloads, 
            you can install our app for better download and update experience. 
          </p>
          <p class="content">GamesToday is NOT associated or affiliated with Google, 
            Google Play or Android in any way. Android is a trademark of Google Inc. 
            All the apps & games are property and trademarks of their respective developer 
            or publisher and for HOME or PERSONAL use ONLY. Please be aware that GamesToday 
            ONLY SHARE THE ORIGINAL APK FILE FOR FREE APPS. ALL THE APK FILES ARE THE SAME 
            AS IN GOOGLE PLAY WITHOUT ANY CHEAT, UNLIMITED GOLD PATCH OR ANY OTHER MODIFICATIONS.
          </p>
          <br />
          <p class="content">If you have any question, please feel free to  contact hotplaygames@hotmail.com</p>
        </div>
        <div class="model">
          <img src="https://cdn.hotplaydl.com/static/img/model.png" alt="">
        </div>
      </div>
    </div>
</div>
</template>
<script>
import { getHotplay } from '@/util/hotplaygames'
export default {
  data() {
    return {
      download: 'https://cdn.hotplaydl.com/static/img/download.png',
      version: '',
      size: ''
    }
  },
  created () {
    let { version,size } = this.$route.query
    this.version = version
    this.size = size
  },
  methods: {
    async downapp() {
      let res = await getHotplay()
      location.href = res.data.url
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  border: 0;
}
@media screen and (min-width: 750px){
  .layout {
    .wrapp {
      background-color: #4A90E2;
    }
  }
}
.layout {
  .header {
    height: 50px;
    background-color: #4A90E2;
    padding-left: 12px;
    &::after {
        display: block;
        content: '';
        clear:both;
    }
    .wrapp {  
      li {
        float: left;
        &:first-child {
            color: white;
            font-size: 12px;
            line-height: 50px;
            opacity: .4;
        }
        &:last-child {
            color: white;
            font-size: 12px;
            line-height: 50px;
        }
      }
    }
  }
  .box {
    padding:12px 12px 0 12px;
    background-image: url('https://cdn.hotplaydl.com/static/img/back-img.png');
    background-repeat: repeat-y;
    background-size:100% 100%;
    width: 100%;
    box-sizing:border-box;
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .box_content {
      max-width: 22rem;
      margin: auto!important;
      .logo {
        img {
          width: 67.5px;
          height: 67.5px;
        }
      }
      .logo-title {
        position: relative;
        font-size: 18px;
        font-family: Roboto-Medium,Roboto;
        font-weight: bold;
        color: #2F3234;
        line-height: 27px;
        margin: 16px 0;
        &::after {
          content: '';
          display: block;
          position: absolute;
          left: 50%;
          bottom: -12px;
          transform: translateX(-50%);

          width: 41px;
          height: 4px;
          background: rgba(75,144,226,1);
          border-radius: 6px;
        }
      }
      .downBtn {
        width: 271px;
        height: 49px;
        background: rgba(74,144,226,1);
        border-radius: 6px;
        margin: 16px 0;
      }
      .version {
        text-align: center;
        width: 100%;
        .version-word {
          display: inline-block;
          font-size: 12px;
          font-family: Roboto-Regular,Roboto;
          font-weight: 400;
          color:#4A90E2;
          line-height: 18px;
          &:nth-child(2) {
            margin-right: 51px;
          }
        }
        img{
          display: inline-block;
          width: 12px;
          height: 12px;
        }
      }
      .content {
        font-size: 14px;
        font-family: Roboto-Regular,Roboto;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        &:first-child {
          margin-top: 14px;
          margin-bottom: 28px;
        }
      }
      .model {
        margin-top: 16px;
        img {
          width: 197px;
          height: 214px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/loadpage.vue